export default __webpack_public_path__ + "static/media/neovim.43e8df0f.svg";